// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"a10015e1","157":"217f3449","408":"f9bdac74","437":"5e3e30d0","460":"c6e1c7a3","532":"e96412ad","639":"6b1d6749","659":"d165a3f1","700":"473a93e4","749":"b5108bea","840":"e1137188","874":"9abceff1"}[chunkId] + ".chunk.js";
};